import { BirimeklePage } from './../birimekle/birimekle';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../../providers/ortak';


@Component({
  selector: 'page-birim-liste',
  templateUrl: 'birim-liste.html',
})
export class BirimListePage {
  aranan = "";
  skip: number = 0;
  take: number = 100;
  BirimListesi = [];

  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.kayitAra(null);
  }

  kayitAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "BirimListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.BirimListesi = sonuc.SonucObject;


    })
  }

  birimkayitlari(e) {

    if (e.keyCode == 13) {
      this.kayitAra(e);
    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(BirimeklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  kayitduzenle(birim) {
    let modal = this.modalCtrl.create(BirimeklePage, { BirimVw: birim });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();

  }
  BirimSil(birim) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();

      formData.append("ID", birim.ID);

      this.bllOrtak.islem(formData, "BirimSil", "", true).then(a => {
        var sonuc = <any>a;
       if(sonuc.Sonuc==1)
       {
        this.ortak.showBasicAlert("Başarılı","Birim başarılı bir şekilde silinmiştir");
        this.kayitAra("");
       }
 
       if(sonuc.Sonuc==0)this.ortak.showBasicAlert("Uyarı","Birim bir ürüne kayıtlı olduğu için silinemedi");
       if(sonuc.Sonuc==99)console.log(sonuc.SonucObject);
      }).catch(x => {

        this.ortak.showErrorAlert();
      })
   

    })

  }
  Islemler(birim) {
    const actionSheet = this.actionSheetCtrl.create({
      title: birim.Name,
      buttons: [
        {
          text: 'Sil',

          handler: () => {
            this.BirimSil(birim);
          }

        },
        {
          text: 'Düzenle',
          handler: () => {
            this.kayitduzenle(birim);
          }
        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/BirimIslemleri/birim-liste/birim-liste.ts